import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LocalizePipe } from '../../pipes/LocalizePipe';

@Component({
  selector: 'app-confirm-dialog-component',
  imports: [ LocalizePipe ],
  templateUrl: './confirm-dialog-component.html',
  styleUrl: './confirm-dialog-component.css',
})
export class ConfirmDialogComponent {
  @Input() message: string = '';
  @Output() confirm = new EventEmitter<boolean>();

  onClose(result: boolean): void {
    this.confirm.emit(result);
  }
}
